import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getCut, addCut, updateCut, deleteCut } from "../../redux/actions/cut.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess";
import { getRights } from "../../redux/actions/userRights.action";

import { ReadCookie } from "../../utils/readCookie";
import { getLog } from "../../redux/actions/log.action"
import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, cutColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';

const { TabPane } = Tabs;
export default function Cut({ token }) {
    TabTitle("Fit Cut")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const cutNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [cutObj, setCutObj] = useState(null);
    const dispatch = useDispatch();
    const { cut, companyAccess, companyAll, getDemoDefaultCompany, log, userRights } = useSelector(state => state)
    const stateData = useSelector((state) => state);
    // const stateData = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [cutName, setCutName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

    const handleEdit = (record, type) => {
        if (type === "active") {
            dispatch(updateCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, cutObj.cut_id, menuId)));
        }
        if (type === "delete") {
            dispatch(deleteCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, cutObj.cut_id, menuId)));
        }
    }

    const createAssignCompany = (record) => {
        dispatch(createCompanyAccess(token, record, cutObj.cut_id, menuId)).then((res) => dispatch(getCompanyAccess(token, cutObj.cut_id, menuId)))
    }

    const companyCol = [
        { title: 'Company ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Minimize" color="#fbfbfb"  >
                    </Tooltip>
                    {
                        record.is_active ?
                            <Tooltip title="Activate" color="#fbfbfb"  ><CheckCircleOutlined className='color-green' onClick={() => handleEdit(record, "active")} /></Tooltip> : <Tooltip title="Deactivate" color="#fbfbfb"  ><CloseCircleOutlined className="color-red" onClick={() => handleEdit(record, "active")} /></Tooltip>}
                    {
                        dCompanyId === record.company_id.toString() ?
                            <Tooltip title="Default company can't be deleted" color="#fbfbfb"  >
                                <DeleteOutlined className='delete-Button' disabled twoToneColor="red"  />
                            </Tooltip> :
                            <Tooltip title="delete" color="#fbfbfb"  >
                                <Popconfirm placement="top" title={"Are you sure to delete this?"} onConfirm={() => handleEdit(record, "delete")} okText="Yes" cancelText="No">
                                    <DeleteOutlined className='delete-Button' twoToneColor="red"  />
                                </Popconfirm>
                            </Tooltip>
                    }
                </>
            ),
        },
    ];
    const companyAccessCol = [
        { title: 'ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    {
                        companyAccess?.payload?.data?.find(m => m.company_id === record?.company_id) ?
                            <>
                                <Tooltip title="Already assigned" color="#fbfbfb"  >
                                    <Button className='modalActionBTN' disabled shape='circle' icon={<CheckCircleOutlined className="color-red" />} />
                                </Tooltip>
                            </> :

                            <Tooltip title="Click to assign" color="#fbfbfb"  >
                                <Button className='modalActionBTN' onClick={() => createAssignCompany(record)} shape='circle' icon={<CloseCircleOutlined className='color-green' />} />
                            </Tooltip>
                    }
                </>
            ),
        },
    ];

    // useEffect(() => {
    //     dispatch(getDefaultCompany(token));
    // }, [token])

    useEffect(() => {
        dispatch(getCut(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (cutObj) {
            setFormState('view')
            form.setFieldsValue({
                id: cutObj.cut_id,
                cut: cutObj.cut_name,
                active: cutObj.is_active
            });
            setCutName(cutObj.cut_name)
            setCheck(cutObj.is_active)
            dispatch(getCompanyAccess(token, cutObj.cut_id, menuId))

        }
    }, [cutObj]);

    useEffect(() => {
        if (cutName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [cutName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            // data: { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }
            dispatch(getLog(token, { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }))
        }
    }

    const formSave = () => {
        if (formState === "add") {
            dispatch(addCut(token, { cutName, check }, menuId)).then((res) => {

                if (res.type === "ADD_CUT_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_CUT_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    dispatch(createCompanyAccess(token, data, res?.payload?.cut_id, menuId)).then((res) => dispatch(getCompanyAccess(token, cutObj.cut_id, menuId)))
                    notification("success", "Cut Created", "Cut created successfully!");
                    form.setFieldsValue({
                        cut: ""
                    })
                    setFormState("")
                    // setCheck(false)
                    setCutName("")
                    setCutObj(null)
                }
                dispatch(getCut(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateCut(token, { cutName, check }, cutObj.cut_id)).then((res) => {
                dispatch(getCut(token, menuId))
                if (res.type === "UPDATE_CUT_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_CUT_SUCCESS") {
                    notification("success", "Cut Update", "Record updated successfully")
                }
                dispatch(getCut(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (cutObj) {
            dispatch(deleteCut(token, cutObj.cut_id)).then((res) => {
                if (res.type === "DELETE_CUT_SUCCESS") {
                    notification("success", "Cut Deleted", "Cut deleted successfully!");
                }
                if (res.type === "DELETE_CUT_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    cut: ""
                })
                // setCheck(false)
                setCutName("")
                setCutObj(null)
                setFormState('')
                dispatch(getCut(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            cutNameInput.current.focus();
            form.setFieldsValue({
                cut: ""
            })
            setCheck(true)
            setCutName("")
            setCutObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Fit/Cutt"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="cut" cutObj={setCutObj} scrollX={"20rem"} scroll={602} perPage={25} source={cut?.payload?.data} col={cutColumns} paginate load={cut.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                    <div className='testStyle' >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 10 }}
                                        >
                                            <div className='customRow styleFormUpper ' >
                                            {cutObj !== null && !(formState === "add") &&
                                             <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().id}
                                                >
                                                    <Input size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Fit/Cut"
                                                name="cut"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().cut}
                                            >

                                                <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={cutNameInput} onChange={(e) => setCutName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                name="active"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                            >
                                                 
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                        </div>
                                        <div className='modalStyle' >

                                            {cutObj === null ?
                                                <Tooltip title="Please select style first" color="#fbfbfb"  >
                                                    <Button disabled={cutObj === null ? true : false} className='' onClick={showModal} >Assign Companies</Button>
                                                </Tooltip>
                                                : <Button type='primary' className='modalButton' onClick={showModal} >Assign Companies</Button>}

                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                                <TabPane tab="Companies" key="1">
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"25rem"} scroll={340} perPage={12} source={(formState === "add") ? getDemoDefaultCompany?.payload?.data : (formState === "edit" || formState === "view" ? companyAccess?.payload?.data : [])} loading={(formState === "add") ? getDemoDefaultCompany.loading : companyAccess.loading} col={companyCol} />
                                                    </div>
                                                </TabPane>
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                        <div className='modalForm' >
                                            <Modal
                                                title="Assign Companies"
                                                visible={visible}
                                                onOk={handleOk}
                                                onCancel={handleCancel}
                                                footer={null}
                                            >
                                                <Tables type="companyAccess" scroll={334} perPage={12} source={companyAll?.payload?.data} col={companyAccessCol} load={companyAll.loading} />
                                            </Modal>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}